// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep .ant-upload-list-item-image {\n  -o-object-fit: contain !important;\n     object-fit: contain !important;\n}\n\n.location-disabled {\n  position: relative;\n  pointer-events: none;\n}\n\n.location-disabled:after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background: #FFFFFF;\n  opacity: 0.6;\n  cursor: not-allowed;\n}", ""]);
// Exports
module.exports = exports;
